let tabs = document.querySelectorAll('.tabbedContent-tab[role="tab"]');

tabs.forEach(tab => {
    tab.addEventListener('click',
        event => {
            event.preventDefault();

            let trigger = event.target;

            trigger.setAttribute('aria-selected', true);
            document.querySelector(decodeURIComponent(trigger.hash)).nextElementSibling.removeAttribute('aria-hidden');

            [...tabs].filter(tab => tab !== event.target).forEach(inactiveTab => {
                inactiveTab.removeAttribute('aria-selected');
                document.querySelector(decodeURIComponent(inactiveTab.hash)).nextElementSibling.setAttribute('aria-hidden', true);
            });

            if ('replaceState' in history) {
                history.replaceState({}, null, trigger.hash);
            }
        });
});

if (document.location.hash) {
    let anchor = document.querySelector(decodeURIComponent(document.location.hash));

    if (anchor.classList.contains('tabbedContent-anchor')) {
        let tab = document.querySelector(`.tabbedContent-tab[href="${decodeURIComponent(document.location.hash)}"]`);
        if (tab) {
            let clickEvent = new Event('click');
            tab.dispatchEvent(clickEvent);
        }
    }
}